var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconForwardGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.2389 2.51598L10.3385 3.40335L14.2122 7.27703L10.3385 11.1507L11.2389 12.0381L16 7.27703L11.2389 2.51598ZM0 0.961244V3.90861C0 5.01416 0.390316 5.95717 1.17095 6.73766C1.95144 7.5183 2.89446 7.90861 4 7.90861H9.74253L6.50042 11.1507L7.40084 12.0381L12.1619 7.27703L7.40084 2.51598L6.50042 3.40335L9.74253 6.64545H4C3.24421 6.64545 2.59916 6.37823 2.06484 5.84377C1.53039 5.30945 1.26316 4.6644 1.26316 3.90861V0.961244H0Z",
    fill: "#183462"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForwardGrey);
export default __webpack_public_path__ + "static/media/icon_forward_grey.279cfcf8ba99240074a487979f6e4b95.svg";
export { ForwardRef as ReactComponent };